import { parseCropString as e, parseFocusString as t } from "../../components/CropDialog/softcrop-lib.es.js";
import { CropDialog as n } from "../../components/CropDialog/CropDialog.es.js";
import { VisualCrop as r } from "../../components/CropDialog/VisualCrop.es.js";
import { VisualFocus as i } from "../../components/CropDialog/VisualFocus.es.js";
import { useRef as a } from "react";
import { Fragment as o, jsx as s, jsxs as c } from "react/jsx-runtime";
import { Element as l, Transforms as u } from "slate";
//#region lib/TTVisual/components/TTVisualImage.tsx
var d = ({ editor: d, children: f, rootNode: p, options: m }) => {
	let { properties: h = { href: "" } } = l.isElement(p) ? p : {}, g = h.href, _ = h?.focus || void 0, v = h?.crop || void 0, y = a(null), b = e(v), x = t(_), S = h.proxy;
	return /* @__PURE__ */ c("div", {
		contentEditable: !1,
		children: [/* @__PURE__ */ c("div", {
			ref: y,
			draggable: !0,
			className: "relative rounded rounded-xs overflow-hidden",
			children: [/* @__PURE__ */ s("img", {
				width: "100%",
				src: S || g
			}), !!m?.enableCrop && /* @__PURE__ */ c(o, { children: [
				b && /* @__PURE__ */ s(r, { crop: b }),
				x && /* @__PURE__ */ s(i, { focus: x }),
				/* @__PURE__ */ s(n, {
					src: S || g,
					area: b,
					point: x,
					onChange: ({ crop: e, focus: t }) => {
						let n = d.children.findIndex((e) => e.id === p?.id);
						if (n < 0) return;
						let r = e ? `${e.x} ${e.y} ${e.w} ${e.h}` : void 0, i = t ? `${t.x} ${t.y}` : void 0;
						u.setNodes(d, { properties: {
							...p.properties,
							crop: r,
							focus: i
						} }, { at: [n] });
					}
				})
			] })]
		}), f]
	});
};
//#endregion
export { d as TTVisualImage };
